import { Configuration, LogLevel, PopupRequest, RedirectRequest, SilentRequest } from "@azure/msal-browser";
import { apiUrl, environment } from './config';

// Helper function to get base URL for redirects
const getBaseUrl = (): string => {
    return window.location.origin;
};

// Helper function to get the client ID based on environment
const getClientId = (): string => {
    // Check for environment variable first
    if (process.env.REACT_APP_CLIENT_ID) {
        return process.env.REACT_APP_CLIENT_ID;
    }

    // Fall back to environment-based configuration
    return environment === 'local' || environment === 'development'
        ? "388f2424-e1b2-4318-892e-dd6e9e871868"
        : environment === 'test'
            ? "2d83eb38-f662-4318-a7c6-aec691f1afc0"
            : "55517471-591a-439b-8721-79fd83fa854d";
};

// Configuration object to be passed to MSAL instance
export const msalConfig: Configuration = {
    auth: {
        clientId: getClientId(),
        authority: process.env.REACT_APP_AUTHORITY || "https://login.microsoftonline.com/e15f8977-7204-465c-91a1-40c7c20de626",
        redirectUri: getBaseUrl(), // Redirect handled in index.tsx before React renders
        postLogoutRedirectUri: getBaseUrl(),
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you're having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                }
            },
            logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Verbose : LogLevel.Warning
        }
    }
};

// Add scopes here for accessing protected resources
export const loginRequest: RedirectRequest | PopupRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE || "api://388f2424-e1b2-4318-892e-dd6e9e871868/user_impersonation"]
};

// Add scopes here for API access (add more as needed)
export const apiRequest: SilentRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE || "api://388f2424-e1b2-4318-892e-dd6e9e871868/user_impersonation"]
};

// Default graph API scope (if needed)
export const graphRequest: SilentRequest = {
    scopes: ["User.Read"]
};